import { Container } from "@mui/material";
import { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
}

const PageContainer = ({ children }: PageContainerProps) => (
  <Container maxWidth="xl">{children}</Container>
);

export default PageContainer;
